// Whitespace is not allowed in canonical FEEL identifiers stored as
// `variable.name` / `formalParameter.name`, because the FEEL parser tokenizes
// idents on whitespace — a stored name like "Credit Score" never matches the
// two-token expression "Credit Score" inside a literal cell. Sanitize at every
// edit point so the stored value is always parser-friendly.
export function sanitizeFeelIdent(name) {
  if (name == null) return name;
  return String(name).replace(/\s+/g, '');
}

const NO_SPACES_HINT = 'Identificador FEEL — sin espacios';

// Attaches space-blocking behavior to an editable element (input or
// contenteditable). The user gets immediate feedback (the space key does
// nothing) and pasted text with whitespace is cleaned before insertion.
export function bindNoSpaces(el) {
  if (!el) return el;
  if (!el.title) el.title = NO_SPACES_HINT;

  el.addEventListener('keydown', (e) => {
    if (e.key === ' ' || e.code === 'Space') e.preventDefault();
  });

  el.addEventListener('paste', (e) => {
    const cd = e.clipboardData || (typeof window !== 'undefined' && window.clipboardData);
    const data = cd && cd.getData ? cd.getData('text') : '';
    if (!data || !/\s/.test(data)) return;
    e.preventDefault();
    const clean = sanitizeFeelIdent(data);
    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
      const start = el.selectionStart != null ? el.selectionStart : el.value.length;
      const end = el.selectionEnd != null ? el.selectionEnd : el.value.length;
      el.value = el.value.slice(0, start) + clean + el.value.slice(end);
      const pos = start + clean.length;
      if (typeof el.setSelectionRange === 'function') el.setSelectionRange(pos, pos);
    } else if (typeof document !== 'undefined' && document.execCommand) {
      document.execCommand('insertText', false, clean);
    }
  });

  return el;
}
